export const DEFAULT_PAGINATION_RECORDS_ARRAY = [10, 50, 100];
export const DEFAULT_PAGINATION_RECORDS_COUNT = 10;
export const DEFAULT_PAGINATION_ACTIVE_PAGE = 1;
export const DEFAULT_PAGINATION_AUDIT_RECORDS_COUNT = 50;
